import {
  Box,
  Flex,
  Stat,
  StatLabel,
  Text,
  Grid,
  GridItem,
  Stack,
  Button,
  Table,
  Tbody,
  Td,
  Tr,
  TableContainer,
  Thead,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Th,
  SimpleGrid,
  useDisclosure,
  HStack
} from '@chakra-ui/react'
import { FC, Key, useState } from 'react'
import Chart from 'react-apexcharts'
import { FaSort, FaSortDown, FaSortUp } from 'react-icons/fa'

import useOptimizerStorange from '@hook/optimizer/use-optimizer-storange'

import { formatToBRL } from '@helper/grid/strings'

import SelectedTableBar from './SelectedTableBar'
const grids = [
  {
    id: 1,
    content: [
      {
        name: 'Perda de Venda R$',
        data: [30, 40, 25, 50, 49, 21, 70]
      },
      {
        name: 'Custo Obsolescecnia',
        data: [30, 43, 25, 56, 43, 21, 70]
      },
      {
        name: 'Custo Financeiro R$',
        data: [23, 33, 25, 46, 23, 11, 50]
      },
      {
        name: 'Otimizado',
        data: [10, 13, 35, 16, 22, 41, 60]
      }
    ]
  },
  {
    id: 2,
    content: [
      {
        name: 'Trade-Off',
        data: [30, 40, 25, 50, 49, 21, 70]
      },
      {
        name: 'Realizado',
        data: [30, 43, 25, 56, 43, 21, 70]
      },
      {
        name: 'Otimizado',
        data: [32, 41, 23, 90, 13, 11, 50]
      }
    ]
  },
  {
    id: 3,
    content: [
      {
        name: 'Politica',
        data: [30, 40, 25, 50, 49, 21, 70]
      }
    ]
  }
  // Adicione mais grids conforme necessário
]

const columns = [
  { key: 'codigoLoja', label: 'Centro' },
  { key: 'produtoId', label: 'Codigo' },
  { key: 'produtoDescricao', label: 'Material' },
  { key: 'categoriaCompacta', label: 'Categoria Compacta' },
  { key: 'curvaABCD', label: 'Curva' },
  { key: 'politicaArbitrada', label: 'Politica Arbitrada' },
  { key: 'politicaOtimizada', label: 'Politica Otimizada' },
  { key: 'diferencaOtimizadaArbitrada', label: 'DIF OTIM. x REAL' },

  { key: 'estoqueMedioRealizadoUltimoAno', label: 'STK MED REAL 12M.' },
  { key: 'estoqueMedioSimuladoUltimoAno', label: 'STK MED OTIM 12M.' },
  { key: 'diferenca', label: 'DIF R$' }
]

export const DataTableOne = () => {
  const { setSelectedlevelAction, dataTradeOffWithPoint } =
    useOptimizerStorange()

  const [data, setData] = useState(dataTradeOffWithPoint)
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' })

  const onSort = (key: string) => {
    let direction = 'asc'
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc'
    }
    setSortConfig({ key, direction })

    const sortedData = [...data].sort((a, b) => {
      if (a[key] < b[key]) {
        return direction === 'asc' ? -1 : 1
      }
      if (a[key] > b[key]) {
        return direction === 'asc' ? 1 : -1
      }
      return 0
    })

    setData(sortedData)
  }

  const getIcon = (key: string) => {
    if (sortConfig.key !== key) {
      return <FaSort />
    }
    if (sortConfig.direction === 'asc') {
      return <FaSortUp />
    }
    return <FaSortDown />
  }
  return (
    <Box>
      <TableContainer
        borderRadius="lg"
        border="1px"
        borderColor="gray.200"
        maxH="600px"
        overflowY="auto"
      >
        <Table size="sm" className="scl-table-grid-v2">
          <Thead bg="#1d5840" color="white" border={10} h={10} fontWeight="700">
            <Tr>
              {/* <Th
                py={2}
                fontWeight="700"
                // onClick={() => onSort(column.key as DataKey)}
                cursor="pointer"
              ></Th> */}
              {columns.map(column => (
                <Th
                  key={column.key}
                  py={2}
                  fontWeight="700"
                  onClick={() => onSort(column.key)}
                  cursor="pointer"
                >
                  <Text
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                    fontWeight="700"
                    color="white"
                    fontSize="14"
                    as="b"
                  >
                    {column.label} {getIcon(column.key)}
                  </Text>
                </Th>
              ))}
            </Tr>
          </Thead>
          <Tbody>
            {data.length !== 0 && (
              <>
                {data.map((row: any, index: Key) => (
                  <Tr
                    key={index}
                    onClick={() => {
                      setSelectedlevelAction(
                        row.produtoDescricao,
                        row.curvaABCD,
                        2
                      )
                    }}
                  >
                    {/* <Td>
                      <IconButton
                        aria-label="Search"
                        icon={<FaEye />}
                        colorScheme="green"
                        variant="simple"
                        size="sm"
                        h={0}
                        onClick={() => {
                          settab(3, null)
                        }}
                      />
                    </Td> */}
                    <Td>{row.lojaId}</Td>
                    <Td>{row.produtoId}</Td>
                    <Td>{row.produtoDescricao}</Td>
                    <Td>{row.categoriaCompacta}</Td>
                    <Td>{row.curvaABCD}</Td>
                    <Td>{row.politicaArbitrada}</Td>
                    <Td>{row.politicaOtimizada}</Td>
                    <Td
                      bg={
                        row.diferencaOtimizadaArbitrada > 0
                          ? 'red.100'
                          : 'green.100'
                      }
                    >
                      {row.diferencaOtimizadaArbitrada}
                    </Td>
                    <Td bg="orange.100">
                      {formatToBRL(row.estoqueMedioRealizadoUltimoAno)}
                    </Td>
                    <Td bg="orange.100">
                      {formatToBRL(row.estoqueMedioSimuladoUltimoAno)}
                    </Td>
                    <Td bg="orange.100">{formatToBRL(row.diferenca)}</Td>

                    {/* <Td
                  bg={
                    row.diferencaPoliticaOtimizadaAtual <= 0
                      ? 'green.100'
                      : 'red.100'
                  }
                >
                  {row.diferencaPoliticaOtimizadaAtual}
                </Td>
                <Td>{row.diferencaEstoqueOtimizadaAtual.toFixed(2)}</Td>
                <Td>{row.leadTimeDias}</Td>
                <Td>{row.frequenciaDias}</Td>
                <Td>{row.multiplicadorPerdaVenda}</Td>
                <Td>{row.custoCapital}</Td> */}
                  </Tr>
                ))}
              </>
            )}
          </Tbody>
        </Table>
      </TableContainer>
    </Box>
  )
}
interface LineChartProps {
  w: number | string
  h: number | string
  content: any[]
  categories: any[]
  type?:
    | 'area'
    | 'line'
    | 'bar'
    | 'histogram'
    | 'pie'
    | 'donut'
    | 'radialBar'
    | 'scatter'
    | 'bubble'
    | 'heatmap'
    | 'treemap'
    | 'boxPlot'
    | 'candlestick'
    | 'radar'
    | 'polarArea'
    | 'rangeBar'
  typeEixoY?: string
}

const LineChart: FC<LineChartProps> = ({
  w,
  h,
  content,
  categories,
  type = 'area',
  typeEixoY
}) => {
  const { isOpen, onClose } = useDisclosure()
  const [selectedPoint] = useState(null)
  const updatedContent = content.map(series => {
    if (series.name === 'Otimizador') {
      return {
        ...series
      }
    }
    return series
  })

  const data = {
    options: {
      chart: {
        type: type
        // events: {
        //   markerClick: handlePointClick
        // }
      },

      xaxis: {
        categories: categories
      },
      yaxis: {
        labels: {
          formatter: function (value: number) {
            if (value !== null) {
              if (typeEixoY === 'real') {
                if (value >= 1000000) {
                  return 'R$ ' + (value / 1000000).toFixed(2) + ' MM'
                } else {
                  return (
                    'R$ ' + value.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
                  )
                }
              } else if (typeEixoY === 'percent') {
                return '' + value.toFixed(2) + ' %'
              } else {
                return value
              }
            }
          }
        },
        tickAmount: 7
      },
      dataLabels: {
        enabled: false
      },
      markers: {
        size: [0, 0, 0, 5, 0], // Especifica tamanhos diferentes para cada série
        fillOpacity: 10
      }
    },
    series: updatedContent
  }

  return (
    // <Box w="full" shadow="md" borderWidth="1px" borderRadius="lg">
    <>
      <Chart
        options={data.options as any}
        series={data.series}
        type={type}
        // height="100%"
        // width="100%"
        height={h}
        id="chart-two-one"
        width={w}
      />
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent bg="white">
          <ModalHeader>Ponto Selecionado</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            {selectedPoint && (
              <Text>
                Você selecionou o ponto com data {selectedPoint.x} e valor{' '}
                {selectedPoint.y}. Deseja continuar?
              </Text>
            )}
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="blue" onClick={onClose}>
              Continuar
            </Button>
            <Button variant="ghost" onClick={onClose} ml={3}>
              Cancelar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>

    // </Box>
  )
}
const LineChart1: FC<LineChartProps> = ({
  w,
  h,
  content,
  categories,
  typeEixoY
}) => {
  const { isOpen, onClose } = useDisclosure()
  const [selectedPoint] = useState(null)

  const updatedContent = content.map(series => {
    if (series.name === 'Otimizador') {
      return {
        ...series
      }
    }
    return series
  })
  const data = {
    options: {
      chart: {
        type: 'line'
        // events: {
        //   markerClick: handlePointClick
        // }
      },

      xaxis: {
        categories: categories
      },
      yaxis: {
        labels: {
          formatter: function (value: number) {
            if (value !== null) {
              if (typeEixoY === 'real') {
                return (
                  'R$ ' + value.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
                )
              } else if (typeEixoY === 'percent') {
                return value !== undefined ? '' + value.toFixed(2) + ' %' : ''
              } else {
                return value
              }
            }
          }
        },
        tickAmount: 7
      },
      dataLabels: {
        enabled: false
      },
      markers: {
        size: 5, // Especifica tamanhos diferentes para cada série
        fillOpacity: 10
      }
    },
    series: updatedContent
  }

  return (
    // <Box w="full" shadow="md" borderWidth="1px" borderRadius="lg">
    <>
      <Chart
        options={data.options as any}
        series={data.series}
        type="line"
        // height="100%"
        // width="100%"
        height={h}
        id="chart-two-two"
        width={w}
      />
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent bg="white">
          <ModalHeader>Ponto Selecionado</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            {selectedPoint && (
              <Text>
                Você selecionou o ponto com data {selectedPoint.x} e valor{' '}
                {selectedPoint.y}. Deseja continuar?
              </Text>
            )}
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="blue" onClick={onClose}>
              Continuar
            </Button>
            <Button variant="ghost" onClick={onClose} ml={3}>
              Cancelar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>

    // </Box>
  )
}

const LineChart2: FC<LineChartProps> = ({
  w,
  h,
  content,
  categories,
  typeEixoY
}) => {
  const { isOpen, onClose } = useDisclosure()
  const [selectedPoint] = useState(null)

  const updatedContent = content.map(series => {
    if (series.name === 'Otimizador') {
      return {
        ...series
      }
    }
    return series
  })
  const data = {
    options: {
      chart: {
        type: 'line'
        // events: {
        //   markerClick: handlePointClick
        // }
      },

      xaxis: {
        categories: categories
      },
      yaxis: {
        labels: {
          formatter: function (value: number) {
            if (value !== null) {
              if (typeEixoY === 'real') {
                return (
                  'R$ ' + value.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
                )
              } else if (typeEixoY === 'percent') {
                return '' + value.toFixed(2) + ' %'
              } else {
                return value
              }
            }
          }
        },
        tickAmount: 7
      },
      dataLabels: {
        enabled: false
      },
      markers: {
        size: 5, // Especifica tamanhos diferentes para cada série
        fillOpacity: 10
      },
      legend: {
        show: true, // Forçar a exibição da legenda
        position: 'top', // Posição da legenda
        horizontalAlign: 'center', // Alinhamento horizontal da legenda
        floating: false // Certifique-se de que a legenda não esteja flutuando
      }
    },
    series: updatedContent
  }

  return (
    // <Box w="full" shadow="md" borderWidth="1px" borderRadius="lg">
    <>
      <Box>
        <Chart
          options={data.options as any}
          series={data.series}
          type="line"
          // height="100%"
          // width="100%"
          height={h}
          width={w}
          id="chart-two-tree"
        />
        <Stack direction="row" spacing={4} justify="center" pb={4}>
          {updatedContent.map((series, index) => (
            <HStack key={index}>
              <Box
                w={3}
                h={3}
                bg="green.500" // ou outra cor específica para a série
                borderRadius="50%"
                mr={2}
              />
              <Text fontSize={12}>{series.name}</Text>
            </HStack>
          ))}
        </Stack>
      </Box>

      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent bg="white">
          <ModalHeader>Ponto Selecionado</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            {selectedPoint && (
              <Text>
                Você selecionou o ponto com data {selectedPoint.x} e valor{' '}
                {selectedPoint.y}. Deseja continuar?
              </Text>
            )}
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="blue" onClick={onClose}>
              Continuar
            </Button>
            <Button variant="ghost" onClick={onClose} ml={3}>
              Cancelar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>

    // </Box>
  )
}

function getClosestIndex(array: number[], target: number): number {
  return array.reduce((closestIndex, currentValue, currentIndex, arr) => {
    return Math.abs(currentValue - target) <
      Math.abs(arr[closestIndex] - target)
      ? currentIndex
      : closestIndex
  }, 0)
}

function insertSorted(arr: number[], num: number): number[] {
  if (arr.includes(num)) {
    return arr // Return the array as is if the number already exists
  }
  const index = arr.findIndex(el => el > num)
  if (index === -1) {
    arr.push(num) // If no element is greater, append at the end
  } else {
    arr.splice(index, 0, num) // Insert at the correct position
  }
  return arr
}
function insertAverageAtIndex(arr: any[], index: number) {
  if (index < 0) {
    throw new Error('Índice inválido. O índice deve ser positivo.')
  }

  let valueToInsert

  if (index >= arr.length) {
    // Copiar o último valor se o índice for maior ou igual ao tamanho do array
    valueToInsert = arr[arr.length - 1]
    // Verificar se o último valor do array é igual ao valor a ser inserido
    if (arr[arr.length - 1] !== valueToInsert) {
      arr.push(valueToInsert)
    }
  } else if (index === 0) {
    // Copiar o primeiro valor se o índice for o primeiro possível
    valueToInsert = arr[0]
    // Verificar se o primeiro valor do array é igual ao valor a ser inserido
    if (arr[0] !== valueToInsert) {
      arr.splice(index, 0, valueToInsert)
    }
  } else {
    // Calcular a média entre o valor anterior e o próximo
    const previousValue = arr[index - 1]
    const nextValue = arr[index]
    valueToInsert = (previousValue + nextValue) / 2

    // Verificar se o valor já existe na posição correta antes de inserir
    if (arr[index] !== valueToInsert) {
      arr.splice(index, 0, valueToInsert)
    }
  }

  return arr
}
const Core2Otimizador: FC = () => {
  const [layout, setLayout] = useState('3x3')
  const [currentGrid, setCurrentGrid] = useState(0)
  const { selectedCategoria, dataProduct } = useOptimizerStorange()
  // eslint-disable-next-line no-var
  var grids1 = []
  let sortedArray: any[] = []
  let sortedArray1: any[] = []
  if (dataProduct !== null) {
    sortedArray = []
    let sortedArray0: any[] = []
    sortedArray0 = dataProduct.graficoTradeOff

    // GRAFICO 1
    // eslint-disable-next-line no-debugger
    // debugger
    // const closestIndex: number = getClosestIndex(
    //   dataProduct.graficoPoliticaEstoqueDias,
    //   dataProduct.politicaEstoqueOtimizada
    // )

    // sortedArray = insertSorted(
    //   dataProduct.graficoPoliticaEstoqueDias,
    //   dataProduct.politicaEstoqueOtimizada
    // )
    // // Mapear os valores para gerar o array final
    // const otimizadorGraph1: (number | null)[] = sortedArray.map((x, index) => {
    //   return index === closestIndex ? dataProduct.custoTotal : null
    // })
    // const graph1 = {
    //   component: 1,
    //   type: 'area',
    //   typeEixoY: 'real',
    //   content: [
    //     {
    //       name: 'Custo Financeiro R$',
    //       data: dataProduct.graficoCustoFinanceiro,
    //       type: 'area',
    //       color: '#F9F871',
    //       markers: {
    //         size: 2 // Remove os pontos do gráfico de área
    //       }
    //     },
    //     {
    //       name: 'Perda de Venda R$',
    //       data: dataProduct.graficoPerdaVenda,
    //       type: 'area',
    //       color: '#04671a',
    //       markers: {
    //         size: 2 // Remove os pontos do gráfico de área
    //       }
    //     },
    //     {
    //       name: 'Custo Obsolescecnia',
    //       data: dataProduct.graficoCustoObsolencia,
    //       type: 'area',
    //       color: '#495255',
    //       markers: {
    //         size: 2 // Remove os pontos do gráfico de área
    //       }
    //     },

    //     {
    //       name: 'Otimizador',
    //       data: otimizadorGraph1,
    //       color: '#110EB8',

    //       type: 'area'
    //     }
    //   ]
    // }

    // grafico 2
    // eslint-disable-next-line no-debugger

    sortedArray1 = insertSorted(
      dataProduct.graficoPoliticaEstoqueDias,
      dataProduct.politicaArbitrada
    )
    sortedArray1 = insertSorted(
      dataProduct.graficoPoliticaEstoqueDias,
      dataProduct.politicaOtimizada
    )

    const closestIndex2: number = getClosestIndex(
      dataProduct.graficoPoliticaEstoqueDias,
      dataProduct.politicaArbitrada
    )
    // Mapear os valores para gerar o array final
    const realizadoGraph: (number | null)[] = sortedArray1.map((x, index) => {
      return index === closestIndex2
        ? dataProduct.politicaEstoqueAtualRuptura
        : null
    })

    const closestIndex3: number = getClosestIndex(
      dataProduct.graficoPoliticaEstoqueDias,
      dataProduct.politicaOtimizada
    )
    // Mapear os valores para gerar o array final
    const otimizadorGraph2: (number | null)[] = sortedArray1.map((x, index) => {
      return index === closestIndex3
        ? dataProduct.politicaEstoqueOtimizadaRuptura
        : null
    })

    if (sortedArray0.length < sortedArray1.length) {
      sortedArray0 = insertAverageAtIndex(sortedArray0, closestIndex2)
      if (dataProduct.politicaOtimizada !== dataProduct.politicaArbitrada) {
        sortedArray0 = insertAverageAtIndex(sortedArray0, closestIndex3)
      }
    }
    const graph2 = {
      component: 2,
      title: 'Ruptura % x Politica de Estoque (Dias)',
      type: 'scatter',
      typeEixoY: 'percent',

      content: [
        {
          name: 'Trade Off',
          data: sortedArray0.map(value => value * 100),
          type: 'line',
          color: '#04671a'
        },

        {
          name: 'Realizado',
          data: realizadoGraph.map(value =>
            value !== null ? value * 100 : value
          ),
          markers: {
            size: 20, // Ajustando o tamanho do marcador para a série "Atual"
            shape: 'diamond' // Forma do marcador como losango
          },
          type: 'line',
          color: '#495255'
        },
        {
          name: 'Otimizador',
          data: otimizadorGraph2.map(value =>
            value !== null ? value * 100 : value
          ),
          markers: {
            size: 20, // Ajustando o tamanho do marcador para a série "Atual"
            shape: 'diamond' // Forma do marcador como losango
          },
          type: 'line',
          color: '#F9F871'
        }
      ]
    }
    const graph3 = {
      component: 3,
      title: 'Estoque R$ x Politica de Estoque (Dias)',
      type: 'scatter',
      typeEixoY: 'real',
      content: [
        {
          name: 'Stk R$ x Stk Dias',
          data: dataProduct.graficoEstoqueMedio,
          type: 'scatter',
          color: '#04671a'
        }
      ]
    }
    // grids1.push(graph1)
    grids1.push(graph2)
    grids1.push(graph3)
  }
  const handleNext = () => {
    setCurrentGrid(prevGrid => (prevGrid + 1) % grids.length)
  }

  const handlePrev = () => {
    setCurrentGrid(prevGrid => (prevGrid - 1 + grids.length) % grids.length)
  }
  return (
    <>
      {selectedCategoria != null && (
        <>
          <SelectedTableBar
            levelSelection={selectedCategoria.level}
            curve={selectedCategoria.curve}
          />
        </>
      )}
      {/* <Grid templateColumns="repeat(3, 1fr)" gap={4}>
        <Box
          bg="gray.200"
          p={4}
          borderRadius="md"
          onClick={() => handleComponentClick('Component1')}
          cursor="pointer"
          transition="0.3s ease-in-out"
          transform={
            selectedComponent === 'Component1' ? 'scale(1.2)' : 'scale(1)'
          }
          boxShadow={selectedComponent === 'Component1' ? 'lg' : 'none'}
        >
          Componente 1
        </Box>
        <Box
          bg="gray.200"
          p={4}
          borderRadius="md"
          onClick={() => handleComponentClick('Component1')}
          cursor="pointer"
          transition="0.3s ease-in-out"
          transform={
            selectedComponent === 'Component1' ? 'scale(1.2)' : 'scale(1)'
          }
          boxShadow={selectedComponent === 'Component1' ? 'lg' : 'none'}
        >
          Componente 2 */}
      {/* </Box> */}
      {/* Outros componentes aqui */}
      {/* {selectedComponent && (
          <Modal isOpen={!!selectedComponent} onClose={handleCloseModal}>
            <ModalOverlay />
            <ModalContent>
              <ModalBody p={0}>
                <Box
                  bg="blue.300"
                  p={4}
                  borderRadius="md"
                  transform="translate(-50%, -50%)"
                  position="fixed"
                  top="50%"
                  left="50%"
                  zIndex="999"
                  boxShadow="lg"
                  maxW={600}
                >
                  <DataTableOne />

                  <button onClick={handleCloseModal}>Fechar</button>
                </Box>
              </ModalBody>
            </ModalContent>
          </Modal>
        )} */}
      {/* </Grid> */}
      {/* <SelectedTableBar /> */}
      <Box display="flex" justifyContent="flex-end" my={2} px={2} mr={8}>
        <Button
          colorScheme="green"
          variant="outline"
          w={5}
          h={8}
          onClick={() => setLayout('3x3')}
        >
          2x2
        </Button>
        <Button
          colorScheme="green"
          variant="outline"
          w={5}
          h={8}
          onClick={() => setLayout('1x1')}
          mx={2}
        >
          1x1
        </Button>
        {layout === '1x1' && (
          <>
            <Button
              onClick={handlePrev}
              colorScheme="blue"
              variant="outline"
              h={8}
              mx={1}
              isDisabled={currentGrid === 0}
            >
              Anterior
            </Button>
            <Button
              onClick={handleNext}
              colorScheme="blue"
              variant="outline"
              h={8}
              mx={1}
              isDisabled={currentGrid === 1}
            >
              Proximo
            </Button>
          </>
        )}
      </Box>
      {dataProduct !== null && (
        <>
          {layout === '3x3' ? (
            <SimpleGrid columns={2} spacing={10} padding={2} ml={4} mr={10}>
              {grids1.map(grid => (
                <Stat
                  // px={{ base: 2, md: 4 }}
                  // py={'5'}
                  shadow={'xl'}
                  border={'1px solid'}
                  borderColor={'gray.800'}
                  rounded={'lg'}
                >
                  <Flex
                    // justifyContent={'space-between'}
                    direction="column"
                    alignItems="center"
                  >
                    <Box
                      bg="#1d5840"
                      color="white"
                      width="100%"
                      textAlign="center"
                      py={2}
                      roundedTop="lg"
                    >
                      <StatLabel
                        bg="#1d5840"
                        fontWeight="700"
                        fontSize="x"
                        isTruncated
                      >
                        <Text fontSize="x" textAlign="center" fontWeight={700}>
                          {grid.title}
                        </Text>
                      </StatLabel>
                    </Box>
                    <Box>
                      {grid.component === 1 ? (
                        <>
                          <LineChart
                            h={300}
                            w={600}
                            content={grid.content}
                            categories={dataProduct.graficoPoliticaEstoqueDias}
                            type={grid.type === 'area' ? 'area' : 'scatter'}
                            typeEixoY={grid.typeEixoY}
                          />
                        </>
                      ) : grid.component === 2 ? (
                        <>
                          <LineChart1
                            h={300}
                            w={600}
                            content={grid.content}
                            categories={dataProduct.graficoPoliticaEstoqueDias}
                            type={grid.type === 'area' ? 'area' : 'scatter'}
                            typeEixoY={grid.typeEixoY}
                          />
                        </>
                      ) : (
                        <>
                          {' '}
                          <LineChart2
                            h={300}
                            w={600}
                            content={grid.content}
                            categories={dataProduct.graficoPoliticaEstoqueDias}
                            type={grid.type === 'area' ? 'area' : 'scatter'}
                            typeEixoY={grid.typeEixoY}
                          />
                        </>
                      )}
                    </Box>
                  </Flex>
                </Stat>
              ))}
            </SimpleGrid>
          ) : (
            <Box textAlign="center">
              <Box
                spacing={10}
                padding={2}
                ml={4}
                mr={10}
                shadow="md"
                borderWidth="1px"
              >
                <Stat
                  // px={{ base: 2, md: 4 }}
                  // py={'5'}
                  shadow={'xl'}
                  border={'1px solid'}
                  borderColor={'gray.800'}
                  rounded={'lg'}
                >
                  <Flex
                    // justifyContent={'space-between'}
                    direction="column"
                    alignItems="center"
                  >
                    <Box
                      bg="#1d5840"
                      color="white"
                      width="100%"
                      textAlign="center"
                      py={2}
                      roundedTop="lg"
                    >
                      <StatLabel
                        bg="#1d5840"
                        fontWeight="700"
                        fontSize="x"
                        isTruncated
                      >
                        <Text fontSize="x" textAlign="center" fontWeight={700}>
                          {grids1[currentGrid].title}
                        </Text>
                      </StatLabel>
                    </Box>
                    <Box>
                      {grids1[currentGrid].component === 1 ? (
                        <>
                          <LineChart
                            h={300}
                            w={1200}
                            content={grids1[currentGrid].content}
                            categories={sortedArray}
                            type={
                              grids1[currentGrid].type === 'area'
                                ? 'scatter'
                                : 'scatter'
                            }
                            typeEixoY={grids1[currentGrid].typeEixoY}
                          />
                        </>
                      ) : grids1[currentGrid].component === 2 ? (
                        <>
                          <LineChart1
                            h={300}
                            w={1200}
                            content={grids1[currentGrid].content}
                            categories={sortedArray1}
                            type={
                              grids1[currentGrid].type === 'area'
                                ? 'scatter'
                                : 'scatter'
                            }
                            typeEixoY={grids1[currentGrid].typeEixoY}
                          />
                        </>
                      ) : (
                        <>
                          <LineChart2
                            h={300}
                            w={1200}
                            content={grids1[currentGrid].content}
                            categories={sortedArray}
                            type={
                              grids1[currentGrid].type === 'area'
                                ? 'scatter'
                                : 'scatter'
                            }
                            typeEixoY={grids1[currentGrid].typeEixoY}
                          />
                        </>
                      )}
                    </Box>
                  </Flex>
                </Stat>
              </Box>
            </Box>
          )}
        </>
      )}

      <Grid
        h={dataProduct !== null ? '400px' : '600px'}
        templateRows="repeat(2, 1fr)"
        templateColumns="repeat(5, 1fr)"
        gap={4}
        p={4}
        pb={20}
      >
        <GridItem pl="2" pb={10} colSpan={6} mr={9}>
          <Box border="1px solid" borderRadius={8} m={0} p={0}>
            <DataTableOne />
          </Box>
        </GridItem>
        {/* <GridItem pl="2" pb={4} colSpan={6} mr={9}>
          <Box border="1px solid" borderRadius={8} m={0} p={0}>
            <DataTable />
          </Box>
        </GridItem> */}
      </Grid>
    </>
  )
}
export default Core2Otimizador
